<template>
  <div>
    <v-dialog v-model="getRlEditNote.show" scrollable persistent max-width="500px">
      <v-card >
        <v-card-title>
          <v-row>
            <v-col cols="12">
              <span class="headline">Edit Note</span>
              <v-alert :value="getRlEditNote.alert.show" dense outlined :type="getRlEditNote.alert.type" :icon="getRlEditNote.alert.icon">{{ getRlEditNote.alert.message }}</v-alert>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-progress-linear :active="dialogLoading" height="3" indeterminate absolute color="primary" />
          <v-container>
              <v-form ref="editNoteForm">
                <v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea v-model="getRlEntry.notes" :rules="[...getRlDialogRules.stringMax255]" counter="255" maxlength="255" label="Notes" rows="1" auto-grow dense />
                    </v-col>
                  </v-row>
                </v-row>
              </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary darken-1" text @click.prevent="closeDialog()" :disabled="dialogLoading">Close</v-btn>
          <v-btn color="primary" @click.prevent="saveDialog()" :disabled="dialogLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    export default {
        data() {
          return{
            dialogLoading: false, 
          }
        },       
        methods: {
          ...mapActions([
            'setRlEditNote',
            'setRlEntryList'
          ]),
          closeDialog() {    
            this.setRlEditNote({show: false, alert: {show: false, type: null, icon: null, message: null}})
          },
          async saveDialog() {
            if (this.$refs.editNoteForm.validate()) {
              try {
                this.dialogLoading = true
                await axios.put('api/v1/recyclingLedgerEntries/' + this.getRlEntry.id, this.getRlEntry)
                this.dialogLoading = false
                this.setRlEditNote({show: false, alert: {show: false, type: null, icon: null, message: null}})
                this.setRlEntryList()
              } catch (error) {
                this.dialogLoading = false     
                this.setRlEditNote({show: true, alert: {show: true, type: "error", icon: "error", message: error.response.data.message}})
              }
            }	
          },
        },
        computed: {
          ...mapGetters([
           'getRlEntry',
           'getRlEditNote',
           'getRlEntry',
           'getRlDialogRules',
          ])
        }
    }
   
</script>